export const moreIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="7"
    viewBox="0 0 47 7"
    fill="none"
  >
    <path
      d="M47 3.66602L42 0.779264V6.55277L47 3.66602ZM0 4.16602H42.5V3.16602H0V4.16602Z"
      fill="#78A934"
    />
  </svg>
);
